import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/repo/client/src/app/(public)/[sport]/teams/[team]/[year]/stats/filter.tsx");
